import React from 'react';
const links = ['Términos y Condiciones', 'Política de Privacidad', 'Contacto'];
export function Footer() {
  return <footer className="bg-brand-text text-white/70 py-12 px-4 text-center text-sm" data-id="element-58" data-mp="3gg0xbxz0nnv0">
      <div className="max-w-4xl mx-auto" data-id="element-59" data-mp="32ovukn0cqfgg">
        <p className="text-white font-serif font-bold text-xl tracking-wide mb-8" data-id="element-60" data-mp="32lrn9grlb3lk">
          YOGA LISTA
        </p>

        <nav aria-label="Enlaces legales" className="flex flex-wrap items-center justify-center gap-6 mb-8" data-id="element-61" data-mp="3uf0mr7ucs6s8">
          {links.map(link => <a key={link} href="#" className="transition-colors duration-150 ease-smooth hover:text-white" data-id="element-62" data-mp="36mu4n8jl4u2">
              {link}
            </a>)}
        </nav>

        <p data-id="element-63" data-mp="29z6woiixuvj2">&copy; 2026 YOGA LISTA — Todos los derechos reservados.</p>
      </div>
    </footer>;
}